import { render, staticRenderFns } from "./SuccessPoint.vue?vue&type=template&id=462912b6&scoped=true&"
import script from "./SuccessPoint.vue?vue&type=script&lang=js&"
export * from "./SuccessPoint.vue?vue&type=script&lang=js&"
import style0 from "./SuccessPoint.vue?vue&type=style&index=0&id=462912b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462912b6",
  null
  
)

export default component.exports